
import App from './app.jsx';
import ReactDOM from 'react-dom';


const Page = {
  blastoff: function () {

    this.mainElement = ReactDOM.hydrate(
      App,
      window.document.getElementById('app-mount')
    );
  },
};


export default Page;


/* $lab:coverage:off$ */
if (!module.parent) {
  window.page = Page;
  Page.blastoff();
}
/* $lab:coverage:on$ */



// WEBPACK FOOTER //
// ./client/pages/main/index.jsx